import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { isAdminState } from '../../recoil/atoms';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * 관리자만 접근 가능한 화면을 감싼다.
 * 세션 복구가 끝나기 전에 튕기지 않도록 App 에서 세션을 먼저 확인한다.
 */
const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const isAdmin = useRecoilValue(isAdminState);

  if (!isAdmin) {
    return <Navigate to="/manager/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
